module.exports = __webpack_public_path__ + "img/modulo_Avatar.dd1b68b.svg";